(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sansencre-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const applyReducedMotion = () => {
      if (!reducedMotion.matches) return;
      document.querySelectorAll('video[autoplay]').forEach((video) => {
        video.removeAttribute('autoplay');
        video.pause();
      });
      document.querySelectorAll('slideshow-component[autoplay], announcement-bar-component[autoplay]').forEach((element) => {
        element.removeAttribute('autoplay');
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyReducedMotion, {once:true});
    } else {
      applyReducedMotion();
    }
    if (typeof reducedMotion.addEventListener === 'function') {
      reducedMotion.addEventListener('change', applyReducedMotion);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sansencre-cookie-preferences"] && !Shopify.designMode) return;
  try {
    (() => {
    const openButton = document.querySelector('[data-cookie-preferences-open]');
    const dialog = document.querySelector('[data-cookie-preferences-dialog]');
    if (!openButton || !dialog) return;

    const closeButton = dialog.querySelector('[data-cookie-preferences-close]');
    const saveButton = dialog.querySelector('[data-cookie-save]');
    const acceptButton = dialog.querySelector('[data-cookie-accept-all]');
    const rejectButton = dialog.querySelector('[data-cookie-reject-all]');
    const status = dialog.querySelector('[data-cookie-status]');
    const inputs = {
      preferences: dialog.querySelector('[data-cookie-consent="preferences"]'),
      analytics: dialog.querySelector('[data-cookie-consent="analytics"]'),
      marketing: dialog.querySelector('[data-cookie-consent="marketing"]')
    };

    const isYes = (value) => value === true || value === 'yes';
    const loadApi = (callback) => {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        callback(window.Shopify.customerPrivacy);
        return;
      }
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        callback(null);
        return;
      }
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], (error) => {
        callback(error ? null : window.Shopify.customerPrivacy);
      });
    };

    const populate = (api) => {
      if (!api || typeof api.currentVisitorConsent !== 'function') return;
      const current = api.currentVisitorConsent();
      inputs.preferences.checked = isYes(current.preferences);
      inputs.analytics.checked = isYes(current.analytics);
      inputs.marketing.checked = isYes(current.marketing);
    };

    const openFallback = () => {
      loadApi((api) => {
        populate(api);
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open','');
      });
    };

    openButton.addEventListener('click', () => {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        Promise.resolve(window.privacyBanner.showPreferences()).catch(openFallback);
        return;
      }
      openFallback();
    });

    const close = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };
    closeButton.addEventListener('click', close);
    dialog.addEventListener('close', () => openButton.focus());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    const apply = (choices) => {
      loadApi((api) => {
        if (!api || typeof api.setTrackingConsent !== 'function') return;
        api.setTrackingConsent(choices, () => {
          inputs.preferences.checked = Boolean(choices.preferences);
          inputs.analytics.checked = Boolean(choices.analytics);
          inputs.marketing.checked = Boolean(choices.marketing);
          if (status) status.textContent = status.dataset.saved || '';
          window.setTimeout(close, 650);
        });
      });
    };

    rejectButton.addEventListener('click', () => apply({preferences:false,analytics:false,marketing:false}));
    acceptButton.addEventListener('click', () => apply({preferences:true,analytics:true,marketing:true}));
    saveButton.addEventListener('click', () => apply({
      preferences:inputs.preferences.checked,
      analytics:inputs.analytics.checked,
      marketing:inputs.marketing.checked
    }));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sansencre-withdrawal"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-sewithdrawal]');
    if (!root) return;
    const form = root.querySelector('#SansEncreWithdrawalForm');
    if (!form) return;

    const success = root.querySelector('[data-sewithdrawal-success]');
    const storageKey = 'sansencre_withdrawal_receipt_v1';

    const makeReference = () => {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return 'SE-' + window.crypto.randomUUID().split('-')[0].toUpperCase();
      }
      return 'SE-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 7).toUpperCase();
    };

    const formatDate = (value) => {
      if (!value) return '—';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return new Intl.DateTimeFormat(document.documentElement.lang || 'fr-FR', {dateStyle:'long'}).format(date);
    };

    const formatDateTime = (value) => {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value || '—';
      return new Intl.DateTimeFormat(document.documentElement.lang || 'fr-FR', {dateStyle:'long', timeStyle:'medium'}).format(date);
    };

    const createReceipt = (payload) => {
      const lines = [
        root.dataset.receiptTitle,
        '',
        root.dataset.receiptMerchant + ' : ' + root.dataset.receiptMerchantValue,
        root.dataset.receiptReference + ' : ' + payload.reference,
        root.dataset.receiptSentAt + ' : ' + formatDateTime(payload.timestamp) + ' (' + payload.timestamp + ')',
        '',
        root.dataset.receiptCustomer + ' : ' + payload.firstName + ' ' + payload.lastName,
        root.dataset.receiptEmail + ' : ' + payload.email,
        root.dataset.receiptOrder + ' : ' + payload.order,
        root.dataset.receiptOrderDate + ' : ' + (payload.orderDate ? formatDate(payload.orderDate) : '—'),
        root.dataset.receiptScope + ' : ' + payload.scopeText,
        root.dataset.receiptProducts + ' : ' + (payload.products || '—'),
        root.dataset.receiptMethod + ' : ' + payload.receiptText,
        '',
        root.dataset.receiptDeclaration + ' :',
        root.dataset.receiptDeclarationText,
        '',
        root.dataset.receiptFooter
      ];
      return lines.join('\n');
    };

    const attachReceipt = (payload, autoDownload) => {
      const content = createReceipt(payload);
      const blob = new Blob([content], {type:'text/plain;charset=utf-8'});
      const url = URL.createObjectURL(blob);
      const download = root.querySelector('[data-receipt-download]');
      const ref = root.querySelector('[data-success-reference]');
      const time = root.querySelector('[data-success-time]');
      if (ref) ref.textContent = payload.reference || '—';
      if (time) time.textContent = formatDateTime(payload.timestamp);
      if (download) {
        download.href = url;
        download.download = 'accuse-reception-retractation-' + (payload.reference || 'sansencre') + '.txt';
        if (autoDownload) setTimeout(() => download.click(), 250);
      }
      return url;
    };

    if (success) {
      try {
        const stored = window.sessionStorage.getItem(storageKey);
        if (stored) attachReceipt(JSON.parse(stored), true);
      } catch (_) {}
      const printButton = root.querySelector('[data-receipt-print]');
      if (printButton) printButton.addEventListener('click', () => window.print());
      try {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('contact_posted');
        window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      } catch (_) {}
      success.focus();
      return;
    }

    const stepForm = root.querySelector('[data-withdrawal-step="form"]');
    const stepConfirm = root.querySelector('[data-withdrawal-step="confirm"]');
    const reviewButton = root.querySelector('[data-withdrawal-review]');
    const editButton = root.querySelector('[data-withdrawal-edit]');
    const scope = root.querySelector('[data-field="scope"]');
    const scopeSubmit = root.querySelector('[data-withdrawal-scope-submit]');
    const productsField = root.querySelector('[data-products-field]');
    const products = root.querySelector('[data-field="products"]');
    const refInput = root.querySelector('[data-withdrawal-ref]');
    const timestampInput = root.querySelector('[data-withdrawal-timestamp]');
    const bodyInput = root.querySelector('[data-withdrawal-body]');

    const updateProductsState = () => {
      const partial = scope && scope.value === 'partial';
      if (productsField) productsField.hidden = !partial;
      if (products) products.required = partial;
    };

    const field = (name) => root.querySelector('[data-field="' + name + '"]');
    const value = (name) => {
      const el = field(name);
      return el ? el.value.trim() : '';
    };

    const optionText = (select) => select && select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '';

    const collect = () => {
      const receiptRadio = root.querySelector('[data-field="receiptMethod"]:checked');
      return {
        firstName: value('firstName'),
        lastName: value('lastName'),
        email: value('email'),
        order: value('order'),
        orderDate: value('orderDate'),
        scope: scope ? scope.value : '',
        scopeText: optionText(scope),
        products: value('products'),
        receiptText: receiptRadio ? receiptRadio.parentElement.innerText.trim().replace(/\s+/g, ' ') : '',
        reference: refInput && refInput.value ? refInput.value : makeReference(),
        timestamp: ''
      };
    };

    const showReview = () => {
      updateProductsState();
      if (!form.reportValidity()) return;
      const payload = collect();
      if (refInput) refInput.value = payload.reference;

      const mappings = {
        name: payload.firstName + ' ' + payload.lastName,
        email: payload.email,
        order: payload.order,
        orderDate: payload.orderDate ? formatDate(payload.orderDate) : '—',
        scope: payload.scopeText,
        products: payload.products || '—',
        receipt: payload.receiptText
      };

      Object.entries(mappings).forEach(([key, val]) => {
        const target = root.querySelector('[data-review="' + key + '"]');
        if (target) target.textContent = val;
      });

      const row = root.querySelector('[data-review-products-row]');
      if (row) row.hidden = payload.scope !== 'partial';

      stepForm.hidden = true;
      stepConfirm.hidden = false;
      stepConfirm.querySelector('h2')?.focus?.();
      stepConfirm.scrollIntoView({behavior:'smooth', block:'start'});
    };

    reviewButton?.addEventListener('click', showReview);
    editButton?.addEventListener('click', () => {
      stepConfirm.hidden = true;
      stepForm.hidden = false;
      stepForm.scrollIntoView({behavior:'smooth', block:'start'});
    });
    scope?.addEventListener('change', updateProductsState);
    updateProductsState();

    form.addEventListener('submit', () => {
      const payload = collect();
      if (scopeSubmit) scopeSubmit.value = payload.scopeText;
      const now = new Date();
      payload.timestamp = now.toISOString();
      if (refInput) refInput.value = payload.reference;
      if (timestampInput) timestampInput.value = payload.timestamp;

      if (bodyInput) {
        bodyInput.value = [
          'DÉCLARATION DE RÉTRACTATION',
          'Référence : ' + payload.reference,
          'Date et heure : ' + payload.timestamp,
          'Nom : ' + payload.firstName + ' ' + payload.lastName,
          'E-mail : ' + payload.email,
          'Commande : ' + payload.order,
          'Date de commande : ' + (payload.orderDate || 'Non renseignée'),
          'Portée : ' + payload.scopeText,
          'Produits : ' + (payload.products || 'Toute la commande'),
          'Moyen électronique pour l’accusé : ' + payload.receiptText,
          'Déclaration : volonté non ambiguë d’exercer le droit de rétractation.'
        ].join('\n');
      }

      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(payload));
      } catch (_) {}
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
